<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 20 20"
        :fill="color"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <path
            d="M0 1.67H20V3.33666H0V1.67ZM0 9.17H20V10.8367H0V9.17ZM0 16.67H20V18.3367H0V16.67Z"
        ></path>
    </svg>
</template>

<script>
export default {
    name: 'HamburgerSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
